import { render, staticRenderFns } from "./MasterSemenar.vue?vue&type=template&id=f3bf63be&"
import script from "./MasterSemenar.vue?vue&type=script&lang=js&"
export * from "./MasterSemenar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports